import React from 'react';
import { useTranslationContext } from "../context/TranslationsProvider";

const SeguroDisclaimer = () => {
    const { translations } = useTranslationContext();
    const t = (key, fallback) => translations[key] || fallback;
    return (
        <>
            <div className="seguro-disclaimer">
                <span className="disclaimer-number">1.</span>
                <p>
                    {t('bdo-libranza-tooltip-insurance', 'Seguro ofrecido por Seguros Alfa S.A que cubre las cuotas del crédito temporalmente en caso de perder el empleo sin justa causa si es empleado o pensionado, o si queda incapacitado como empleado del sector oficial. En ambos casos cubre el diagnóstico de enfermedades graves y de cáncer femenino o masculino.')}
                </p>
            </div>
            <div className="seguro-disclaimer">
                <p>
                    {t('bdo-libranza-insurance-legal-disclaimer', 'El valor de la tasa es de referencia para la simulación. Estos datos son una proyección estimada y no representan una oferta comercial. Conoce el valor final en la formalización de la oferta.')}
                </p>
            </div>
        </>
    );
};

export default SeguroDisclaimer;
